import * as yup from "yup";

import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Slide,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { cyan, red } from "@mui/material/colors";
import {
  useAddNewRoleMutation,
  useDeleteRoleMutation,
} from "../../../lib/cvsSlice";

import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Select from "react-select";
import StarsIcon from "@mui/icons-material/Stars";
import { options } from "config";
import useFormPersist from "react-hook-form-persist";
import { yupResolver } from "@hookform/resolvers/yup";

const cvSchema = yup.object().shape({
  roles: yup.array().required("Role is required"),
  otherRole: yup.string(),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Roles = ({ roles, cvId }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState();
  const [roleState, setRoleState] = useState([roles]);
  const [role, setRole] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [otherRole, setOtherRole] = useState("");

  const handleOpen = (mode) => {
    setOpen(true);
    setMode(mode);
  };

  const handleClose = () => {
    reset();
    setOtherRole("");
    setRole([]);
    setSelectedRole([]);
    setOpen(false);
  };

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(cvSchema),
    defaultValues: {
      roles: [],
      otherRole: "",
    },
  });

  const [addNewRole] = useAddNewRoleMutation();

  const submitResults = async (e) => {
    const newRole = e;
    await addNewRole({ cvId, roles: [newRole] })
      .then((result) => {
        handleClose();
        console.log("this is the result", result)
        roles.push(newRole);
        toast.success("Role(s) added successfully");
      })
      .catch((error) => {
        console.log("Add new Role(s) error:", error);
      });
  };

  const [deleteRole] = useDeleteRoleMutation();
  const handleRemove = async (item) => {
    await deleteRole({ cvId, roleId: item }).unwrap();
    const updatedRole = roleState.filter((exp) => exp.id !== item);
    setRoleState(updatedRole);
    roles.splice(
      roles.findIndex((exp) => exp._id === item),
      1
    );
    setRole([...roles]);
    toast.info("Role removed successfully");
  };

  const handleEdit = () => { };

  useFormPersist("roles", {
    watch,
    setValue,
    reset,
    storage: window.localStorage, // default window.sessionStorage
  });

  const handleOnChange = (selectedOption) => {
    if (selectedOption && selectedOption.length > 5) {
      // Limit the selections to a maximum of 5
      selectedOption = selectedOption.slice(0, 5);

      // Show a toast notification about the maximum number of expertise reached
      toast.info('You have reached the maximum number of highlighted roles (5).', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    const selectedValues = selectedOption
      ? selectedOption.map((option) => option.value)
      : [];
    setSelectedRole(selectedValues);
    setValue("roles", selectedValues); // update form value

    if (selectedValues.includes("other")) {
      // If "Other" option is selected, clear the otherExpertise state
      setOtherRole("");
    }
  };

  const handleOtherRoleChange = (event) => {
    setOtherRole(event.target.value);
    localStorage.setItem(`otherRole_${cvId}`, event.target.value);
    console.log("Other Role:", event.target.value);
  };

  useEffect(() => {
    const data = localStorage.getItem("roles");
    if (data !== null) {
      setRole(JSON.parse(data));
    }

    const otherRoleData = localStorage.getItem("otherRole");
    if (otherRoleData !== null) {
      setOtherRole(otherRoleData);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("roles", JSON.stringify(role));
  }, [role]);

  return (
    <div id="roles">
      <ToastContainer autoClose={1500} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ marginTop: "20px", padding: "15px" }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              sx={{ marginTop: "5px" }}
            >
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={9}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      component="div"
                      sx={{ p: 0, pb: 0 }}
                    >
                      Highlighted Roles
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Tooltip
                      title="Maximum role(s) 5"
                      placement="bottom"
                    >
                      <IconButton
                        aria-label="add"
                        onClick={() => handleOpen("add")}
                        disabled={roleState?.length >= 1 && roleState[0]?.length !== 0}
                        color={roleState?.length >= 1 && roleState[0]?.length !== 0 ? "disabled" : "primary"}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  <Grid item xs={1}>
                    <IconButton
                      aria-label="edit"
                      onClick={() => handleOpen("edit")}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {roles?.map((exp) => (
                  <List key={exp._id} sx={{ padding: "0px" }}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: cyan[700] }}>
                          <StarsIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ paddingLeft: "10px" }}
                        primary={
                          <Typography variant="subtitle2" component="div">
                            Role(s)
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography variant="caption" component="span">
                              {exp.roles.join(", ")}
                            </Typography>
                            {otherRole && <Typography variant="caption" display="block">
                              Other roles: {otherRole}
                            </Typography>}
                          </>
                        }
                      />
                    </ListItem>
                  </List>
                ))}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {mode === "add" && (
          <form autoComplete="off" onSubmit={handleSubmit(submitResults)}>
            <DialogTitle>Add new Main Role(s)</DialogTitle>
            <DialogContent dividers sx={{ width: '500px'}}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ padding: "20px" }}
              >
                <Grid item xs={12}>
                  <Controller
                    name="role"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange } }) => {
                      return (
                        <Select
                          error={!!errors.roles}
                          options={options}
                          placeholder="Start typing your highlighted role"
                          noOptionsMessage={() =>
                            "The mentioned highlighted role isn't available"
                          }
                          isClearable
                          isMulti
                          isSearchable
                          fullWidth
                          helperText={
                            errors?.roles ? errors.roles?.message : ""
                          }
                          onChange={handleOnChange}
                          value={options.filter((option) =>
                            selectedRole.includes(option.value)
                          )}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            control: (base) => ({
                              ...base,
                              minHeight: 70,
                            }),
                          }}
                          menuPortalTarget={document.body}
                        />
                      );
                    }}
                  />
                </Grid>
                {selectedRole.includes("other") && (
                  <Grid item xs={12}>
                    <TextField
                      label="Other Role"
                      value={otherRole}
                      onChange={handleOtherRoleChange}
                      fullWidth
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                sx={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
        {mode === "edit" && (
          <form>
            <DialogTitle>Edit/Remove Role</DialogTitle>
            <DialogContent dividers>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ marginTop: "5px" }}
              >
                <Grid item xs={12}>
                  {roles?.map((exp) => (
                    <List key={exp._id} sx={{ padding: "0px" }}>
                      <ListItem
                        sx={{ paddingLeft: "10px" }}
                        secondaryAction={
                          <Stack
                            alignItems="flex-end"
                            direction="row"
                            paddingBottom="15px"
                          >
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleEdit(exp._id, "editnew")}
                              sx={{ margin: "0px", padding: "0px" }}
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleRemove(exp._id)}
                              sx={{ margin: "0px", padding: "0px" }}
                            >
                              <DeleteIcon sx={{ color: red[400] }} />
                            </IconButton>
                          </Stack>
                        }
                      >
                        <ListItemText
                          sx={{ paddingRight: "20px", margin: "0px" }}
                          primary={
                            <Typography variant="subtitle2" component="div">
                              Role(s):
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography variant="caption" display="block">
                                {exp.roles.join(", ")}
                              </Typography>
                              {otherRole && <Typography variant="caption" display="block">
                                Other role: {otherRole}
                              </Typography>}
                            </>
                          }
                        />
                      </ListItem>
                    </List>
                  ))}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                sx={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
      </Dialog>
    </div>
  );
};

export default Roles;